import { Subject } from 'rxjs'
import { RxJS } from './RxJS'
import { RxJSStateDefinable } from '../Types/Types'

const reportingMenuTriggerSubject: Subject<Definable<boolean>> = new Subject<Definable<boolean>>()

RxJS.reportingMenuTrigger = RxJS.reportingMenuTrigger ?? {
    subject: reportingMenuTriggerSubject,
    observable: reportingMenuTriggerSubject.asObservable(),
    announce: (data?: boolean): void => reportingMenuTriggerSubject.next(data)
}

export const reportingMenuTrigger$: RxJSStateDefinable<boolean> = RxJS.reportingMenuTrigger
